import {
  Box,
  Button,
  IconButton,
  Link,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined'
import AddIcon from '@mui/icons-material/Add'
import { unlinkFrontTicket } from '../../Apis/routes/front'

export const LinkedFrontTicketsTable = ({
  ticketId,
  navigateToSearchView,
  frontTickets,
  setFrontTickets,
}) => {
  const handleUnlinkFrontTicket = async (frontTicketId) => {
    await unlinkFrontTicket(ticketId, frontTicketId)

    setFrontTickets((prevState) =>
      prevState.filter(
        (frontTicket) => frontTicket.frontConversation !== frontTicketId
      )
    )
  }

  return (
    <>
      {frontTickets.length > 0 && (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="left">ID</TableCell>
                <TableCell align="left">Lien</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {frontTickets.map((frontTicket) => (
                <TableRow
                  key={frontTicket.id}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell component="th" scope="row" align="left">
                    {frontTicket.frontConversation}
                  </TableCell>
                  <TableCell align="left">
                    <Link
                      href={`https://app.frontapp.com/open/${frontTicket.frontConversation}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      https://app.frontapp.com/open/
                      {frontTicket.frontConversation}
                    </Link>
                  </TableCell>
                  <TableCell>
                    <IconButton
                      size="small"
                      onClick={async () => {
                        await handleUnlinkFrontTicket(
                          frontTicket.frontConversation
                        )
                      }}
                      aria-label="unlink"
                    >
                      <DeleteOutlineOutlinedIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      <Box
        sx={{
          position: 'sticky',
          bottom: 0,
          backgroundColor: 'background.paper',
          paddingY: 2,
          borderTop: 1,
          borderColor: 'divider',
          zIndex: 1,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            color="primary"
            onClick={navigateToSearchView}
            size="large"
          >
            Rattacher une conversation front
          </Button>
        </Box>
      </Box>
    </>
  )
}
